import { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Loading from "../Loading";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [role, setRole] = useState(null);
    const [token, setToken] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    const logout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userData");
        setToken(null);
        setUser(null);
        setIsAuthenticated(false);
    };


    const login = (userData, token, role) => {
        setToken(token);
        setUser(userData);
        setRole(role)
        // console.log('userData', userData)
        setIsAuthenticated(true);

        // sessionStorage only lasts until browser/tab closes
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("userData", JSON.stringify(userData));
    };

    useEffect(() => {
        const storedToken = sessionStorage.getItem("token");
        const storedUser = sessionStorage.getItem("userData");
        if (storedToken && storedUser) {
            const decoded = jwtDecode(storedToken);
            setToken(storedToken);
            setUser(JSON.parse(storedUser));
            setIsAuthenticated(true);
            setRole(decoded.role);

        }
        setLoading(false);
    }, []);

    return (
        <AuthContext.Provider value={{ user, role, token, isAuthenticated, login, logout, loading }}>
            {loading ? <Loading /> : children}
        </AuthContext.Provider >
    );
};

export const useAuth = () => useContext(AuthContext);